import { useMemo } from "react"

import { useParams } from "@Components/RouterProvider"
import createStore from "@Stores/base-factories"
import { hookFormList, hookOfferList, hookPublisherList, hookMetaFieldList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useAllocationFactory = ({ fetch, siteSelected: { id: siteId } }) => {
  const { id } = useParams()

  return useMemo(() => ({
    propagatePayout: async payload => await fetch({
      method: 'post',
      url: `/allocation/${id}/payout`,
      data: {
        ...payload,
        siteId,
      },
    }),
    duplicate: async payload => await fetch({
      method: 'post',
      url: `/allocation/duplicate`,
      data: {
        ...payload,
      },
    }),
    listSiteVerifications: async params => await fetch({
      url: `/site/${siteId}/verifications`,
      params,
    }),
  }), [fetch, siteId, id])
}

const clearPayload = payload => {
  // eslint-disable-next-line no-unused-vars
  const { _, conversion_steps, deleted_at, deletedAt, updated_at, formConversionStepsOptions, formOptions, mobile_conversion_steps, mobileFormOptions, mult_domain, offerOptions, payout_types, publisher, publisherOptions, revenueMethod, site, verificationsSite, ...rest } = payload
  return rest
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extendHookCollectionFactory('allocation', true, clearPayload)
  .extendHookCollectionsFactory('allocations')
  .extend(useAllocationFactory)
  .extend(hookFormList())
  .extend(hookOfferList())
  .extend(hookPublisherList())
  .extend(hookMetaFieldList())
  .factory()

export {
  Provider as AllocationProvider,
  useStore as useAllocationStore,
}
